import React from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import Checkbox from "material-ui/Checkbox"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { IUserRole } from "../../../models"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import PayTypeSelectChip from "../../../components/paytype/PayTypeSelectChip"

interface IProps {
	role: IUserRole
	selected: boolean
	saveRole(role: IUserRole, permissionCheckBox: boolean): void
}
interface IState {
	permissions: string[]
	expensePayTypes: string[]
	roleRowOrder: string[][]
}

export default class AccountRolesTableRowExtendPanel extends React.Component<IProps, IState> {
	private allPermissions: string[]
	private roleRowColCount
	private roleOrderForAllFeature
	constructor(props: IProps) {
		super(props)
		this.state = {
			permissions: props.role.Permissions,
			expensePayTypes: props.role.ExpensePayTypes || [],
			roleRowOrder: [],
		}
		autobind(this)
		this.allPermissions = permissionHelper.getAllPermissions(AccountStore.getCurrentAccount())
		this.roleRowColCount = 6
		this.roleOrderForAllFeature = [
			{ name: "Account", colCount: 1 },
			{ name: "ImportCSV", colCount: 1 },
			{ name: "Employees", colCount: 3 },
			{ name: "Punch_Records", colCount: 1 },
			{ name: "Timecards", colCount: 1 },
			{ name: "Jobs", colCount: 2 },
			{ name: "Payroll", colCount: 1 + (AccountStore.getExpensesEnabled() ? AccountStore.getTimecardAmountExpensesEnabled() ? 0 : 1 : 0) },
			{ name: "Devices", colCount: 3 + (AccountStore.getJobsEnabled() ? 1 : 0) },
			{ name: "Equipment", colCount: 1 },
			{ name: "Accrual", colCount: 2 },
			{ name: "Leave_Tracking", colCount: 2 },
			{ name: "Schedule", colCount: 3 },
			{ name: "Expense", colCount: 1 },
			{ name: "Clients", colCount: 1 },
			{ name: "Rewards", colCount: 1 },
			{ name: "Trends", colCount: 1 },
			{ name: "HR_SETTINGS", colCount: 4 },
			{ name: "HR_MENU_ACCESS", colCount: 1 + (AccountStore.getEnableMessageCenter() ? 1 : 0) + (AccountStore.getEnableATS() ? 1 : 0) },
			{ name: "HR_PEOPLE_DETAIL_ACCESS", colCount: 4 },
			{ name: "HR_PEOPLE_ACCESS", colCount: 5 },
		]
	}

	componentDidMount() {
		this.setRoleRowOrder()
	}

	setRoleRowOrder() {
		let roleOrder = this.roleOrderForAllFeature.slice()
		if (!AccountStore.getTimecardEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Timecards")
		if (!AccountStore.getPayrollEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Payroll")
		if (!AccountStore.getEquipmentEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Equipment")
		if (!AccountStore.getAccrualsTimeoffEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Accrual")
		if (!AccountStore.getAccrualsTimeoffEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Leave_Tracking")
		if (!AccountStore.getScheduleEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Schedule")
		if (!AccountStore.getExpensesEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Expense")
		if (!AccountStore.getJobsEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Jobs")
		if (!AccountStore.getTrendsEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Trends")
		if (!AccountStore.getClientsEnabled()) roleOrder = roleOrder.filter(role => role.name !== "Clients")
		if (!AccountStore.getHREnabled()) roleOrder = roleOrder.filter(
			role => role.name !== "Rewards" &&
				role.name !== "HR_SETTINGS" &&
				role.name !== "HR_USER_ACCESS" &&
				role.name !== "HR_PEOPLE_ACCESS" &&
				role.name !== "HR_MENU_ACCESS" &&
				role.name !== "HR_PEOPLE_DETAIL_ACCESS")

		const roleRowOrder = []
		let totalColCountOfRole = 0
		roleOrder.forEach((role, index) => {
			if (totalColCountOfRole === 0) {
				roleRowOrder.push([role.name])
				totalColCountOfRole += role.colCount
			}
			else if (totalColCountOfRole + role.colCount > this.roleRowColCount) {
				roleRowOrder.push([role.name])
				totalColCountOfRole = role.colCount
			}
			else {
				roleRowOrder[roleRowOrder.length - 1].push(role.name)
				totalColCountOfRole += role.colCount
			}
		})
		this.setState({ roleRowOrder })
	}

	checkForPermissionCheckBox(permission) {
		return this.state.permissions.indexOf(permission) > -1
	}


	handleCheck(e, checked) {
		const permission = e.target.name
		if (
			(permission === "AllPermissions" || permission === AuthenticationStore.Permissions.Account.AccountAdmin) &&
			!checked &&
			this.props.role.Id === AuthenticationStore.getLoggedInUser().UserRoleId
		) {
			AppStateStore.setProgressSnackbarContent(strings.You_cannot_remove_your_AccountAdmin_permission)
			return
		}
		let permissions = this.state.permissions.slice()
		if (permission === "AllPermissions") {
			this.allPermissions.forEach((item) => {
				permissions = this.setPermission(permissions, item, checked)
			})
		} else {
			permissions = this.setPermission(permissions, permission, checked)
			permissions = this.getPermissionsWithDependencies(permissions, permission, checked)
		}
		this.setState({ permissions }, () =>
			this.handleSave()
		)
	}

	handleSave() {
		const role = this.props.role
		role.Permissions = this.state.permissions
		role.ExpensePayTypes = this.state.expensePayTypes
		this.props.saveRole && this.props.saveRole(role, true)
	}

	getPermissionsWithDependencies(permissions, permission, checked) {
		if (checked && permission === AuthenticationStore.Permissions.Account.AccountAdmin) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewFullHierarchy, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewHierarchyTab, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Account.ViewRates) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.EditRates, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Account.EditRates) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewRates, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Account.AccountAdmin) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportPunchCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportEmployeesCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportJobsCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Import.ImportScheduleCSV, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ExportFailedPunches, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewHierarchyTab, false)

			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Account.EditHierarchy) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewHierarchyTab, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Account.ViewHierarchyTab) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.EditHierarchy, false)

			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices, false)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Employees.ViewEmployees) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.EditEmployees, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.AddEmployees, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.DeleteEmployees, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.ViewUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.EditUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.AddUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.DeleteUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.ViewUserSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.EditUserSchedule, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Employees.EditEmployees ||
				permission === AuthenticationStore.Permissions.Employees.AddEmployees ||
				permission === AuthenticationStore.Permissions.Employees.DeleteEmployees)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Employees.ViewCustomEmployeeFields) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.EditCustomEmployeeFields, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Employees.EditCustomEmployeeFields) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewCustomEmployeeFields, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.PunchRecords.ViewRecords) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.PunchRecords.EditExceptions, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.PunchRecords.EditSuspense, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.PunchRecords.EditExceptions ||
			permission === AuthenticationStore.Permissions.PunchRecords.EditSuspense)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.PunchRecords.ViewRecords, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Devices.ViewAllDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditAllDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddAllDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteAllDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.InitDevices, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Devices.EditAllDevices ||
				permission === AuthenticationStore.Permissions.Devices.AddAllDevices ||
				permission === AuthenticationStore.Permissions.Devices.DeleteAllDevices ||
				permission === AuthenticationStore.Permissions.Devices.InitDevices)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewAllDevices, true)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Devices.ViewHierarchyDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewHierarchyTab, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Devices.ViewHierarchyDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddHierarchyDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Devices.EditHierarchyDevices ||
				permission === AuthenticationStore.Permissions.Devices.AddHierarchyDevices ||
				permission === AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewHierarchyDevices, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Account.ViewHierarchyTab, true)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Devices.ViewJobDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.ViewJobs, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Devices.ViewJobDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditJobDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddJobDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteJobDevices, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Devices.EditJobDevices ||
				permission === AuthenticationStore.Permissions.Devices.AddJobDevices ||
				permission === AuthenticationStore.Permissions.Devices.DeleteJobDevices)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewJobDevices, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.ViewJobs, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Devices.ViewUserDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddUserDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteUserDevices, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Devices.ViewUserDevices) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Devices.EditUserDevices ||
				permission === AuthenticationStore.Permissions.Devices.AddUserDevices ||
				permission === AuthenticationStore.Permissions.Devices.DeleteUserDevices)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewUserDevices, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Timecards.ViewTimecards) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.EditTimecards, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ApproveTimecards, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.GlobalPunchAdd, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.GlobalPunchEdit, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ViewPayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.LockPayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ClosePayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ExportPayroll, false)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, false)
			}
			if (AccountStore.getPunchRuleEnabled()) {
				permission = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.PunchRuleOverride, false)
			}
		}
		else if (checked && permission === AuthenticationStore.Permissions.Timecards.ViewTimecards) {
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, true)
			}
		}
		else if (!checked && (permission === AuthenticationStore.Permissions.Timecards.EditTimecards || permission === AuthenticationStore.Permissions.Timecards.ApproveTimecards)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.LockPayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ClosePayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ExportPayroll, false)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, false)
			}
		}
		else if (checked && (permission === AuthenticationStore.Permissions.Timecards.ApproveTimecards || permission === AuthenticationStore.Permissions.Timecards.EditTimecards)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ViewTimecards, true)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, true)
			}
		}
		else if (checked && (permission === AuthenticationStore.Permissions.Timecards.GlobalPunchAdd || permission === AuthenticationStore.Permissions.Timecards.GlobalPunchEdit)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ViewTimecards, true)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Payroll.ViewPayroll) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ViewTimecards, true)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, true)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, true)
			}
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Payroll.ViewPayroll) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.LockPayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ClosePayroll, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ExportPayroll, false)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, false)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, false)
			}
		}
		else if (checked && (permission === AuthenticationStore.Permissions.Payroll.LockPayroll || permission === AuthenticationStore.Permissions.Payroll.ExportPayroll || permission === AuthenticationStore.Permissions.Payroll.ClosePayroll)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ViewTimecards, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.EditTimecards, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Timecards.ApproveTimecards, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Payroll.ViewPayroll, true)
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, true)
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, true)
				if (permission === AuthenticationStore.Permissions.Payroll.LockPayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, true)
				}
				if (permission === AuthenticationStore.Permissions.Payroll.ClosePayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, true)
				}
				if (permission === AuthenticationStore.Permissions.Payroll.ExportPayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, true)
				}
			}
		}
		else if (!checked && (permission === AuthenticationStore.Permissions.Payroll.LockPayroll || permission === AuthenticationStore.Permissions.Payroll.ExportPayroll || permission === AuthenticationStore.Permissions.Payroll.ClosePayroll)) {
			if (AccountStore.getTimecardTimeExpensesEnabled()) {
				if (permission === AuthenticationStore.Permissions.Payroll.LockPayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, false)
				}
				if (permission === AuthenticationStore.Permissions.Payroll.ClosePayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, false)
				}
				if (permission === AuthenticationStore.Permissions.Payroll.ExportPayroll) {
					permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, false)
				}
			}
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Equipment.ViewEquipment) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Equipment.AddEquipment, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Equipment.EditEquipment, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Equipment.DeleteEquipment, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Equipment.AddEquipment ||
				permission === AuthenticationStore.Permissions.Equipment.EditEquipment ||
				permission === AuthenticationStore.Permissions.Equipment.DeleteEquipment)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Equipment.ViewEquipment, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Accrual.ViewAccrual) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.AddAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.EditAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.DeleteAccrual, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Accrual.AddAccrual ||
			permission === AuthenticationStore.Permissions.Accrual.EditAccrual ||
			permission === AuthenticationStore.Permissions.Accrual.DeleteAccrual
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.ViewAccrual, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Accrual.ViewUserAccrual) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.AddUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.EditUserAccrual, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.DeleteUserAccrual, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Accrual.ViewUserAccrual) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Accrual.AddUserAccrual ||
			permission === AuthenticationStore.Permissions.Accrual.EditUserAccrual ||
			permission === AuthenticationStore.Permissions.Accrual.DeleteUserAccrual
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Accrual.ViewUserAccrual, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.AddLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.LeaveTracking.AddLeaveTracking ||
			permission === AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking ||
			permission === AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking ||
			permission === AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking ||
			permission === AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Schedule.ViewSchedule) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.AddSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.EditSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.DeleteSchedule, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Schedule.AddSchedule ||
			permission === AuthenticationStore.Permissions.Schedule.EditSchedule ||
			permission === AuthenticationStore.Permissions.Schedule.DeleteSchedule
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.ViewSchedule, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Schedule.ViewUserSchedule) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.EditUserSchedule, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Schedule.ViewUserSchedule) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
		}
		else if (checked && permission === AuthenticationStore.Permissions.Schedule.EditUserSchedule) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewEmployees, true)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.ViewUserSchedule, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.AddAccountSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.EditAccountSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Schedule.AddAccountSchedule ||
			permission === AuthenticationStore.Permissions.Schedule.EditAccountSchedule ||
			permission === AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Schedule.ViewAccountSchedule, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Expense.ViewEmployeeExpense) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.EditEmployeeExpense, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.AddEmployeeExpense, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.DeleteEmployeeExpense, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Expense.EditEmployeeExpense ||
			permission === AuthenticationStore.Permissions.Expense.AddEmployeeExpense ||
			permission === AuthenticationStore.Permissions.Expense.DeleteEmployeeExpense ||
			permission === AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewEmployeeExpense, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Expense.ViewPayrollExpense) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.LockPayrollExpense, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ClosePayrollExpense, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ExportPayrollExpense, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Expense.LockPayrollExpense ||
			permission === AuthenticationStore.Permissions.Expense.ExportPayrollExpense ||
			permission === AuthenticationStore.Permissions.Expense.ClosePayrollExpense
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Expense.ViewPayrollExpense, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Jobs.ViewJobs) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.EditJobs, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.AddJobs, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.DeleteJobs, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.EditCustomJobFields, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.EditJobClientSelection, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobAttributes, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobWorkerPool, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewAssignedEmployee, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobTimecard, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobSchedule, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobLocation, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.EditJobLocation, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewPhases, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobPositions, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobExpenses, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobBudget, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.EditJobBudget, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobPhotos, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobSettings, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.ViewJobDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.AddJobDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.EditJobDevices, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Devices.DeleteJobDevices, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Jobs.EditJobs ||
				permission === AuthenticationStore.Permissions.Jobs.AddJobs ||
				permission === AuthenticationStore.Permissions.Jobs.DeleteJobs ||
				permission === AuthenticationStore.Permissions.Jobs.EditCustomJobFields ||
				permission === AuthenticationStore.Permissions.Jobs.EditJobClientSelection ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobAttributes ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobWorkerPool ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewAssignedEmployee ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobTimecard ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobSchedule ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobLocation ||
				permission === AuthenticationStore.Permissions.JobTabs.EditJobLocation ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewPhases ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobPositions ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobExpenses ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobBudget ||
				permission === AuthenticationStore.Permissions.JobTabs.EditJobBudget ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobPhotos ||
				permission === AuthenticationStore.Permissions.JobTabs.ViewJobSettings
			)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Jobs.ViewJobs, true)
			if (permission === AuthenticationStore.Permissions.JobTabs.EditJobBudget) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobBudget, true)
			}
			if (permission === AuthenticationStore.Permissions.JobTabs.EditJobLocation) {
				permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.ViewJobLocation, true)
			}
		}
		else if (!checked && permission === AuthenticationStore.Permissions.JobTabs.ViewJobBudget) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.EditJobBudget, false)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.JobTabs.ViewJobLocation) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.JobTabs.EditJobLocation, false)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Clients.ViewClients) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Clients.EditClients, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Clients.AddClients, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Clients.DeleteClients, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Clients.EditCustomClientFields, false)
		}
		else if (
			checked &&
			(permission === AuthenticationStore.Permissions.Clients.EditClients ||
				permission === AuthenticationStore.Permissions.Clients.AddClients ||
				permission === AuthenticationStore.Permissions.Clients.DeleteClients ||
				permission === AuthenticationStore.Permissions.Clients.EditCustomClientFields)
		) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Clients.ViewClients, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Rewards.ViewRewards) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Rewards.AddRewards, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Rewards.EditRewards, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Rewards.DeleteRewards, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Rewards.AddRewards ||
			permission === AuthenticationStore.Permissions.Rewards.EditRewards ||
			permission === AuthenticationStore.Permissions.Rewards.DeleteRewards
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Rewards.ViewRewards, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.HRAccessATS.View) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessATS.Add, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessATS.Edit, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessATS.Delete, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessATS.AllowAccessToAllJobPostings, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.HRAccessATS.Add ||
			permission === AuthenticationStore.Permissions.HRAccessATS.Edit ||
			permission === AuthenticationStore.Permissions.HRAccessATS.Delete ||
			permission === AuthenticationStore.Permissions.HRAccessATS.AllowAccessToAllJobPostings
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessATS.View, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.HRAccessMessageCenter.View) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessMessageCenter.Delete, false)
		}
		else if (checked && permission === AuthenticationStore.Permissions.HRAccessMessageCenter.Delete) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessMessageCenter.View, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.Employees.ViewFile) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.AddFile, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.DeleteFile, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.Employees.AddFile ||
			permission === AuthenticationStore.Permissions.Employees.DeleteFile
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.Employees.ViewFile, true)
		}
		else if (!checked && permission === AuthenticationStore.Permissions.HRAccessCampaigns.View) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessCampaigns.Add, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessCampaigns.Edit, false)
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessCampaigns.Delete, false)
		}
		else if (checked && (
			permission === AuthenticationStore.Permissions.HRAccessCampaigns.Add ||
			permission === AuthenticationStore.Permissions.HRAccessCampaigns.Edit ||
			permission === AuthenticationStore.Permissions.HRAccessCampaigns.Delete
		)) {
			permissions = this.setPermission(permissions, AuthenticationStore.Permissions.HRAccessCampaigns.View, true)
		}
		return permissions
	}

	setPermission(permissions, permission, checked) {
		if (checked) {
			!permissions.includes(permission) && permissions.push(permission)
		} else {
			permissions.includes(permission) && permissions.splice(permissions.indexOf(permission), 1)
		}
		return permissions
	}

	getEmptyColArray(row) {
		let totalRoleColCount = 0
		row.forEach((roleName) => {
			totalRoleColCount += this.roleOrderForAllFeature.find((role) => role.name === roleName).colCount
		})
		let emptyColArray = []
		for (let i = 0; i < this.roleRowColCount - totalRoleColCount; i++) {
			emptyColArray.push(i)
		}
		return emptyColArray
	}

	render() {
		return (
			<div style={{ minWidth: 1400 }}>
				{this.state.roleRowOrder.map((row, index) =>
					<Table
						key={index}
						selectable={false}
						multiSelectable={false}
						style={{ backgroundColor: this.props.selected ? "rgb(224, 224, 224)" : "inherit" }}
					>
						<TableHeader displaySelectAll={false} adjustForCheckbox={false} enableSelectAll={false} style={{ height: 20 }}>
							<TableRow style={{ height: 20 }}>
								{row.map((roleName, roleIndex) => {
									const columns = []
									const roleString = () => {
										if (roleName === "Jobs") {
											if (checkJobFieldAvailable("plural")) {
												return AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel
											}
										}
										return strings[roleName]
									}
									for (let i = 0; i < this.roleOrderForAllFeature.find((role) => role.name === roleName).colCount; i++) {
										columns.push(<TableHeaderColumn style={styles.colHeader} key={`${roleIndex}-${i}`}>{i === 0 && roleString()}</TableHeaderColumn>)
									}
									return columns
								})}
								{this.getEmptyColArray(row).map((item, emptyIndex) =>
									<TableHeaderColumn style={styles.colHeader} key={`empty${emptyIndex}`}></TableHeaderColumn>
								)}
							</TableRow>
						</TableHeader>
						<TableBody displayRowCheckbox={false}>
							<TableRow>
								{row.includes("Account") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AllPermissions"}
											name="AllPermissions"
											label={strings.All_Permissions}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.allPermissions.every((item) => this.state.permissions.indexOf(item) > -1)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AccountAdmin"}
											name={AuthenticationStore.Permissions.Account.AccountAdmin}
											label={strings.Account_Admin}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
										/>
										{!AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForAccountUserUnlessAssigned && (
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewAllHierarchy"}
												name={AuthenticationStore.Permissions.Account.ViewFullHierarchy}
												label={strings.View_Full_Hierarchy}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ViewFullHierarchy)}
												disabled={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
											/>
										)}
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewHierarchyTab"}
											name={AuthenticationStore.Permissions.Account.ViewHierarchyTab}
											label={strings.View_Hierarchy_Tab}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ViewHierarchyTab)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditHierarchy"}
											name={AuthenticationStore.Permissions.Account.EditHierarchy}
											label={strings.Edit_Hierarchy}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.EditHierarchy)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewRate"}
											name={AuthenticationStore.Permissions.Account.ViewRates}
											label={strings.View_Rates}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ViewRates)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditRate"}
											name={AuthenticationStore.Permissions.Account.EditRates}
											label={strings.Edit_Rates}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.EditRates)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewScheduledJobs"}
											name={AuthenticationStore.Permissions.Account.ViewScheduledJobs}
											label={strings.View_Scheduled_Jobs}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ViewScheduledJobs)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ExportFailedPunches"}
											name={AuthenticationStore.Permissions.Account.ExportFailedPunches}
											label={strings.Export_Failed_Punches}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ExportFailedPunches)}
											disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewTimeReports"}
											name={AuthenticationStore.Permissions.Account.ViewTimeReports}
											label={strings.View_Time_Reports}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.ViewTimeReports)}
										/>
									</TableRowColumn>
								}
								{row.includes("ImportCSV") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-PunchData"}
											name={AuthenticationStore.Permissions.Import.ImportPunchCSV}
											label={strings.Punch_Data}
											style={styles.checkBox}
											iconStyle={styles.input}
											disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportPunchCSV)}
										/>
										{AccountStore.getExpensesEnabled() && [
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-TimeData"}
												key="time"
												name={AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV}
												label={strings.Expense_Time_Data}
												style={styles.checkBox}
												iconStyle={styles.input}
												disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportExpenseTimeCSV)}
											/>,
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ExpenseAmountData"}
												key="amount"
												name={AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV}
												label={strings.Expense_Amount_Data}
												style={styles.checkBox}
												iconStyle={styles.input}
												disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportExpenseAmountCSV)}
											/>
										]}
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EmployeeImport"}
											key="employeeImport"
											name={AuthenticationStore.Permissions.Import.ImportEmployeesCSV}
											label={strings.Employee_Import}
											style={styles.checkBox}
											iconStyle={styles.input}
											disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportEmployeesCSV)}
										/>
										{AccountStore.getJobsEnabled() &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-JobImport"}
												key="jobImport"
												name={AuthenticationStore.Permissions.Import.ImportJobsCSV}
												label={checkJobFieldAvailable('singular') ? `Import ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Data` : strings.Import_Job_Data}
												style={styles.checkBox}
												iconStyle={styles.input}
												disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportJobsCSV)}
											/>
										}
										{AccountStore.getScheduleEnabled() &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ScheduleImport"}
												key="scheduleImport"
												name={AuthenticationStore.Permissions.Import.ImportScheduleCSV}
												label={strings.Import_Schedule_Data}
												style={styles.checkBox}
												iconStyle={styles.input}
												disabled={!this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Account.AccountAdmin)}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Import.ImportScheduleCSV)}
											/>
										}

									</TableRowColumn>
								}
								{row.includes("Employees") && [
									<TableRowColumn style={styles.col} key="employees1">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AllowSelfEmployeeEdit"}
											name={AuthenticationStore.Permissions.Employees.AllowSelfEmpEdit}
											label={strings.Allow_Self_Emp_Edit}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.AllowSelfEmpEdit)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployees"}
											name={AuthenticationStore.Permissions.Employees.ViewEmployees}
											label={strings.View_Employees}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.ViewEmployees)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEmployees"}
											name={AuthenticationStore.Permissions.Employees.EditEmployees}
											label={strings.Edit_Employees}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.EditEmployees)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEmployees"}
											name={AuthenticationStore.Permissions.Employees.AddEmployees}
											label={strings.Add_Employees}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.AddEmployees)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEmployees"}
											name={AuthenticationStore.Permissions.Employees.DeleteEmployees}
											label={strings.Delete_Employees}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.DeleteEmployees)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="employees2">
										{AccountStore.getSupervisorDirectReportEnabled() &&
											<div style={{ ...styles.checkBox, position: "relative", height: 32 }}>
												<Checkbox
													data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewAllEmployees"}
													key="toggle"
													name={AuthenticationStore.Permissions.SupervisorDirectReport.ViewAllEmployees}
													label={strings.View_All_Employees}
													iconStyle={styles.input}
													onCheck={this.handleCheck}
													checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.SupervisorDirectReport.ViewAllEmployees)}
												/>
												<span key="secondLabel" style={{ position: "absolute", top: 15, left: 29 }}>{`(${strings.Non_Direct_Report})`}</span>
											</div>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.ViewCustomEmployeeFields}
											label={strings.View_Custom_Employee_Fields}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.ViewCustomEmployeeFields)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.EditCustomEmployeeFields}
											label={strings.Edit_Custom_Employee_Fields}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.EditCustomEmployeeFields)}
										/>
										{AccountStore.getSupervisorDirectReportEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees}
												label={strings.Can_add_non_direct_report_employees}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees)}
											/>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.EditProfilePic}
											label={strings.Edit_Profile_Pic}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.EditProfilePic)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.EditFaceSpaces}
											label={strings.Edit_Face_Spaces}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.EditFaceSpaces)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="employees3">
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.ViewFile}
											label={strings.View_File}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.ViewFile)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.AddFile}
											label={strings.Add_File}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.AddFile)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Employees.DeleteFile}
											label={strings.Delete_File}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Employees.DeleteFile)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Punch_Records") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewRecords"}
											name={AuthenticationStore.Permissions.PunchRecords.ViewRecords}
											label={strings.View_Records}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.PunchRecords.ViewRecords)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditExceptions"}
											name={AuthenticationStore.Permissions.PunchRecords.EditExceptions}
											label={strings.Edit_Exceptions}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.PunchRecords.EditExceptions)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditSuspensePunch"}
											name={AuthenticationStore.Permissions.PunchRecords.EditSuspense}
											label={strings.Edit_Suspense_Punch}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.PunchRecords.EditSuspense)}
										/>
									</TableRowColumn>
								}
								{row.includes("Timecards") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewTimecards"}
											name={AuthenticationStore.Permissions.Timecards.ViewTimecards}
											label={strings.View_Timecards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.ViewTimecards)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditTimecards"}
											name={AuthenticationStore.Permissions.Timecards.EditTimecards}
											label={strings.Edit_Timecards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.EditTimecards)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ApproveTimecards"}
											name={AuthenticationStore.Permissions.Timecards.ApproveTimecards}
											label={strings.Approve_Timecards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.ApproveTimecards)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-GlobalPunchAdd"}
											name={AuthenticationStore.Permissions.Timecards.GlobalPunchAdd}
											label={strings.Global_Punch_Add}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.GlobalPunchAdd)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AllPermissions"}
											name={AuthenticationStore.Permissions.Timecards.GlobalPunchEdit}
											label={strings.Global_Punch_Edit}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.GlobalPunchEdit)}
										/>
										{AccountStore.getPunchRuleEnabled() &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AllPermissions"}
												name={AuthenticationStore.Permissions.Timecards.PunchRuleOverride}
												label={strings.Punch_Rule_Override}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.PunchRuleOverride)}
											/>
										}
										{AccountStore.getCurrentAccountSettings().FeatureSettings.EnablePriorPeriodAdjustments &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-PriorPeriodTimecard"}
												name={AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustments}
												label={strings.Prior_Period_Adjustments}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustments)}
											/>
										}
										{AccountStore.getCurrentAccountSettings().FeatureSettings.EnablePriorPeriodAdjustments &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ApproveTimecards"}
												name={AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustmentsExportEdits}
												title={strings.Allow_Prior_Period_Adjustment_Exports}
												label={
													<div className="TextOverflow" style={{ width: 180 }}>
														{strings.Allow_Prior_Period_Adjustment_Exports}
													</div>
												}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Timecards.PriorPeriodAdjustmentsExportEdits)}
											/>
										}
									</TableRowColumn>
								}
								{row.includes("Jobs") && [
									<TableRowColumn style={styles.col} key="jobs">
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.ViewJobs}
											label={checkJobFieldAvailable('plural') ? `View ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.View_Jobs}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.ViewJobs)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.AddJobs}
											label={checkJobFieldAvailable('plural') ? `Add ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Add_Jobs}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.AddJobs)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.EditJobs}
											label={checkJobFieldAvailable('plural') ? `Edit ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Edit_Jobs}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.EditJobs)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.DeleteJobs}
											label={checkJobFieldAvailable('plural') ? `Delete ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Delete_Jobs}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.DeleteJobs)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.EditCustomJobFields}
											label={checkJobFieldAvailable('singular') ? `Edit Custom ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Fields` : strings.Edit_Custom_Job_Fields}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.EditCustomJobFields)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Jobs.EditJobClientSelection}
											label={strings.Allow_Client_Selection_Edit}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Jobs.EditJobClientSelection)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="job_tabs">
										{AccountStore.getNoteAttributesEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobAttributes}
												label={strings.View_Attributes}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobAttributes)}
											/>
										}
										{AccountStore.getCRMEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobWorkerPool}
												label={strings.View_Worker_Pool}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobWorkerPool)}
											/>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.ViewAssignedEmployee}
											label={strings.View_Assigned_Employee}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewAssignedEmployee)}
										/>
										{AccountStore.getTimecardEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobTimecard}
												label={strings.View_Timecard}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobTimecard)}
											/>
										}
										{AccountStore.getScheduleEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobSchedule}
												label={strings.View_Schedule}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobSchedule)}
											/>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.ViewJobLocation}
											label={checkJobFieldAvailable('singular') ? `View ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Location` : strings.View_Job_Location}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobLocation)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.EditJobLocation}
											label={checkJobFieldAvailable('singular') ? `Edit ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Location` : strings.Edit_Job_Location}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.EditJobLocation)}
										/>
										{AccountStore.getPhasesEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewPhases}
												label={strings.View_Phases}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewPhases)}
											/>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.ViewJobPositions}
											label={strings.View_Positions}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobPositions)}
										/>
										{AccountStore.getExpensesEnabled() && AccountStore.getCRMEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobExpenses}
												label={strings.View_Expenses}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobExpenses)}
											/>
										}
										{AccountStore.getPayClassEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.ViewJobBudget}
												label={strings.View_Budget}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobBudget)}
											/>
										}
										{AccountStore.getPayClassEnabled() &&
											<Checkbox
												name={AuthenticationStore.Permissions.JobTabs.EditJobBudget}
												label={strings.Edit_Budget}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.EditJobBudget)}
											/>
										}
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.ViewJobPhotos}
											label={strings.View_Photos}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobPhotos)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.JobTabs.ViewJobSettings}
											label={strings.View_Settings}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.JobTabs.ViewJobSettings)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Payroll") && [
									<TableRowColumn style={styles.col} key="PayrollTime">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewPayroll"}
											name={AuthenticationStore.Permissions.Payroll.ViewPayroll}
											label={strings.View_Payroll}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.ViewPayroll)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-LockPayroll"}
											name={AuthenticationStore.Permissions.Payroll.LockPayroll}
											label={strings.Lock_Payroll}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.LockPayroll)}
										/>
										{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ClosePayroll"}
												name={AuthenticationStore.Permissions.Payroll.ClosePayroll}
												label={strings.Close_Payroll}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.ClosePayroll)}
											/>
										}
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ExportPayroll"}
											name={AuthenticationStore.Permissions.Payroll.ExportPayroll}
											label={strings.Export_Payroll}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.ExportPayroll)}
										/>
										{AccountStore.getJobsEnabled() &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewPayrollByJob"}
												name={AuthenticationStore.Permissions.Payroll.ViewPayrollByJob}
												label={checkJobFieldAvailable('singular') ? `View Payroll By ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.View_Payroll_By_Job}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob)}
											/>
										}
										{AccountStore.getEnableSupervisorLock() &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditPayrollAfterLock"}
												name={AuthenticationStore.Permissions.Payroll.EditPayrollAfterLock}
												label={strings.Edit_Payroll_After_Lock}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Payroll.EditPayrollAfterLock)}
											/>
										}
									</TableRowColumn>,
									AccountStore.getExpensesEnabled() && !AccountStore.getTimecardAmountExpensesEnabled() &&
									<TableRowColumn style={styles.col} key="PayrollExpense">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewPayrollExpense"}
											name={AuthenticationStore.Permissions.Expense.ViewPayrollExpense}
											label={strings.View_Payroll_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.ViewPayrollExpense)}
											disabled={AccountStore.getTimecardTimeExpensesEnabled()}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-LockPayrollExpense"}
											name={AuthenticationStore.Permissions.Expense.LockPayrollExpense}
											label={strings.Lock_Payroll_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.LockPayrollExpense)}
											disabled={AccountStore.getTimecardTimeExpensesEnabled()}
										/>
										{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
											<Checkbox
												data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ClosePayrollExpense"}
												name={AuthenticationStore.Permissions.Expense.ClosePayrollExpense}
												label={strings.Close_Payroll_Expense}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.ClosePayrollExpense)}
												disabled={AccountStore.getTimecardTimeExpensesEnabled()}
											/>
										}
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ExportPayrollExpense"}
											name={AuthenticationStore.Permissions.Expense.ExportPayrollExpense}
											label={strings.Export_Payroll_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.ExportPayrollExpense)}
											disabled={AccountStore.getTimecardTimeExpensesEnabled()}
										/>
									</TableRowColumn>
								]}
								{row.includes("Devices") && [
									<TableRowColumn style={Object.assign(styles.col, { overflow: "none" })} key="AllDevices">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewAllDevices"}
											name={AuthenticationStore.Permissions.Devices.ViewAllDevices}
											label={strings.View_All_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.ViewAllDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditAllDevices"}
											name={AuthenticationStore.Permissions.Devices.EditAllDevices}
											label={strings.Edit_All_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.EditAllDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddAllDevices"}
											name={AuthenticationStore.Permissions.Devices.AddAllDevices}
											label={strings.Add_All_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.AddAllDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteAllDevices"}
											name={AuthenticationStore.Permissions.Devices.DeleteAllDevices}
											label={strings.Delete_All_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.DeleteAllDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-InitDevices"}
											name={AuthenticationStore.Permissions.Devices.InitDevices}
											label={strings.Init_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.InitDevices)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={Object.assign(styles.col, { overflow: "none" })} key="UserDevices">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployeeDevices"}
											name={AuthenticationStore.Permissions.Devices.ViewUserDevices}
											label={strings.View_Employee_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.ViewUserDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditUserDevices"}
											name={AuthenticationStore.Permissions.Devices.EditUserDevices}
											label={strings.Edit_Employee_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.EditUserDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEmployeeDevices"}
											name={AuthenticationStore.Permissions.Devices.AddUserDevices}
											label={strings.Add_Employee_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.AddUserDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEmployeeDevices"}
											name={AuthenticationStore.Permissions.Devices.DeleteUserDevices}
											label={strings.Delete_Employee_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.DeleteUserDevices)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={Object.assign(styles.col, { overflow: "none" })} key="HierarchyDevices">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewHierarchyDevices"}
											name={AuthenticationStore.Permissions.Devices.ViewHierarchyDevices}
											label={strings.View_Hierarchy_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.ViewHierarchyDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditHierarchyDevices"}
											name={AuthenticationStore.Permissions.Devices.EditHierarchyDevices}
											label={strings.Edit_Hierarchy_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.EditHierarchyDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddHierarchyDevices"}
											name={AuthenticationStore.Permissions.Devices.AddHierarchyDevices}
											label={strings.Add_Hierarchy_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.AddHierarchyDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteHierarchyDevices"}
											name={AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices}
											label={strings.Delete_Hierarchy_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices)}
										/>
									</TableRowColumn>,
									AccountStore.getJobsEnabled() &&
									<TableRowColumn style={Object.assign(styles.col, { overflow: "none" })} key="JobDevices">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewJobDevices"}
											name={AuthenticationStore.Permissions.Devices.ViewJobDevices}
											label={checkJobFieldAvailable('singular') ? `View ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Devices` : strings.View_Job_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.ViewJobDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditJobDevices"}
											name={AuthenticationStore.Permissions.Devices.EditJobDevices}
											label={checkJobFieldAvailable('singular') ? `Edit ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Devices` : strings.Edit_Job_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.EditJobDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddJobDevices"}
											name={AuthenticationStore.Permissions.Devices.AddJobDevices}
											label={checkJobFieldAvailable('singular') ? `Add ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Devices` : strings.Add_Job_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.AddJobDevices)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteJobDevices"}
											name={AuthenticationStore.Permissions.Devices.DeleteJobDevices}
											label={checkJobFieldAvailable('singular') ? `Delete ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Devices` : strings.Delete_Job_Devices}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Devices.DeleteJobDevices)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Equipment") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEquipment"}
											name={AuthenticationStore.Permissions.Equipment.ViewEquipment}
											label={strings.View_Equipment}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Equipment.ViewEquipment)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEquipment"}
											name={AuthenticationStore.Permissions.Equipment.EditEquipment}
											label={strings.Edit_Equipment}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Equipment.EditEquipment)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEquipment"}
											name={AuthenticationStore.Permissions.Equipment.AddEquipment}
											label={strings.Add_Equipment}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Equipment.AddEquipment)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEquipment"}
											name={AuthenticationStore.Permissions.Equipment.DeleteEquipment}
											label={strings.Delete_Equipment}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Equipment.DeleteEquipment)}
										/>
									</TableRowColumn>
								}
								{row.includes("Accrual") && [
									<TableRowColumn style={styles.col} key="Accrual">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewAccrual"}
											name={AuthenticationStore.Permissions.Accrual.ViewAccrual}
											label={strings.View_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.ViewAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditAccrual"}
											name={AuthenticationStore.Permissions.Accrual.EditAccrual}
											label={strings.Edit_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.EditAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddAccrual"}
											name={AuthenticationStore.Permissions.Accrual.AddAccrual}
											label={strings.Add_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.AddAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteAccrual"}
											name={AuthenticationStore.Permissions.Accrual.DeleteAccrual}
											label={strings.Delete_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.DeleteAccrual)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="EmployeeAccrual">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployeeAccrual"}
											name={AuthenticationStore.Permissions.Accrual.ViewUserAccrual}
											label={strings.View_Employee_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.ViewUserAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEmployeeAccrual"}
											name={AuthenticationStore.Permissions.Accrual.EditUserAccrual}
											label={strings.Edit_Employee_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.EditUserAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEmployeeAccrual"}
											name={AuthenticationStore.Permissions.Accrual.AddUserAccrual}
											label={strings.Add_Employee_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.AddUserAccrual)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEmployeeAccrual"}
											name={AuthenticationStore.Permissions.Accrual.DeleteUserAccrual}
											label={strings.Delete_Employee_Accrual}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Accrual.DeleteUserAccrual)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Leave_Tracking") && [
									<TableRowColumn style={styles.col} key="LeaveTracking">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AllowUserToEditOwnLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.AllowSupervisorToApproveDenyOwnLeaveRequests}
											label={strings.Allow_Supervisor_To_Approve_Deny_Own_Leave_Requests}
											style={styles.checkBox}
											labelStyle={{ whiteSpace: "initial" }}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.AllowSupervisorToApproveDenyOwnLeaveRequests)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking}
											label={strings.View_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking}
											label={strings.Edit_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.AddLeaveTracking}
											label={strings.Add_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.AddLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking}
											label={strings.Delete_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.DeleteLeaveTracking)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="EmployeeLeaveTracking">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployeeLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking}
											label={strings.View_Employee_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEmployeeLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking}
											label={strings.Edit_Employee_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.EditUserLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEmployeeLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking}
											label={strings.Add_Employee_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.AddUserLeaveTracking)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEmployeeLeaveTracking"}
											name={AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking}
											label={strings.Delete_Employee_Leave_Tracking}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.LeaveTracking.DeleteUserLeaveTracking)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Schedule") && [
									<TableRowColumn style={styles.col} key="AccountSchedule">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewAccountSchedule"}
											name={AuthenticationStore.Permissions.Schedule.ViewAccountSchedule}
											label={strings.View_Account_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditAccountSchedule"}
											name={AuthenticationStore.Permissions.Schedule.EditAccountSchedule}
											label={strings.Edit_Account_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddAccountSchedule"}
											name={AuthenticationStore.Permissions.Schedule.AddAccountSchedule}
											label={strings.Add_Account_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.AddAccountSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteAccountSchedule"}
											name={AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule}
											label={strings.Delete_Account_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="Schedule">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewSchedule"}
											name={AuthenticationStore.Permissions.Schedule.ViewSchedule}
											label={strings.View_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.ViewSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditSchedule"}
											name={AuthenticationStore.Permissions.Schedule.EditSchedule}
											label={strings.Edit_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.EditSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddSchedule"}
											name={AuthenticationStore.Permissions.Schedule.AddSchedule}
											label={strings.Add_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.AddSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteSchedule"}
											name={AuthenticationStore.Permissions.Schedule.DeleteSchedule}
											label={strings.Delete_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.DeleteSchedule)}
										/>
									</TableRowColumn>,
									<TableRowColumn style={styles.col} key="EmployeeSchedule">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployeeSchedule"}
											name={AuthenticationStore.Permissions.Schedule.ViewUserSchedule}
											label={strings.View_Employee_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.ViewUserSchedule)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEmployeeSchedule"}
											name={AuthenticationStore.Permissions.Schedule.EditUserSchedule}
											label={strings.Edit_Employee_Schedule}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Schedule.EditUserSchedule)}
										/>
									</TableRowColumn>
								]}
								{row.includes("Expense") && [
									<TableRowColumn style={styles.col} key="EmployeeExpenseDetail">
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ViewEmployeeExdpense"}
											name={AuthenticationStore.Permissions.Expense.ViewEmployeeExpense}
											label={strings.View_Employee_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.ViewEmployeeExpense)}
											disabled={AccountStore.getTimecardTimeExpensesEnabled()}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-EditEmployeeExpense"}
											name={AuthenticationStore.Permissions.Expense.EditEmployeeExpense}
											label={strings.Edit_Employee_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.EditEmployeeExpense)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-AddEmployeeExpense"}
											name={AuthenticationStore.Permissions.Expense.AddEmployeeExpense}
											label={strings.Add_Employee_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.AddEmployeeExpense)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-DeleteEmployeeExpense"}
											name={AuthenticationStore.Permissions.Expense.DeleteEmployeeExpense}
											label={strings.Delete_Employee_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.DeleteEmployeeExpense)}
										/>
										<Checkbox
											data-intercom-target={"AccountRoles-ExtendPanel-Checkbox-ApproveEmployeeExpense"}
											name={AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense}
											label={strings.Approve_Employee_Expense}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Expense.ApproveEmployeeExpense)}
										/>
										<div style={{ marginTop: 10 }}>
											<PayTypeSelectChip
												title={strings.Allowed_Expense_Paytypes}
												selectedPayTypeIds={this.state.expensePayTypes}
												disAllowEmpty
												handleChange={expensePayTypes => this.setState({ expensePayTypes }, () => this.handleSave())}
											/>
										</div>
									</TableRowColumn>
								]}
								{row.includes("Clients") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											name={AuthenticationStore.Permissions.Clients.ViewClients}
											label={strings.View_Clients}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Clients.ViewClients)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Clients.AddClients}
											label={strings.Add_Clients}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Clients.AddClients)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Clients.EditClients}
											label={strings.Edit_Clients}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Clients.EditClients)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Clients.DeleteClients}
											label={strings.Delete_Clients}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Clients.DeleteClients)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Clients.EditCustomClientFields}
											label={strings.Edit_Custom_Client_Fields}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Clients.EditCustomClientFields)}
										/>
									</TableRowColumn>
								}
								{row.includes("Rewards") &&
									<TableRowColumn style={styles.col}>
										<Checkbox
											name={AuthenticationStore.Permissions.Rewards.ViewRewards}
											label={strings.View_Rewards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Rewards.ViewRewards)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Rewards.AddRewards}
											label={strings.Add_Rewards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Rewards.AddRewards)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Rewards.EditRewards}
											label={strings.Edit_Rewards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Rewards.EditRewards)}
										/>
										<Checkbox
											name={AuthenticationStore.Permissions.Rewards.DeleteRewards}
											label={strings.Delete_Rewards}
											style={styles.checkBox}
											iconStyle={styles.input}
											onCheck={this.handleCheck}
											checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Rewards.DeleteRewards)}
										/>
									</TableRowColumn>
								}

								{row.includes("Trends") && AccountStore.getTrendsEnabled() &&
									[
										<TableRowColumn style={styles.col} key={"Trends"}>
											<Checkbox
												name={AuthenticationStore.Permissions.Trends.ViewTrends}
												label={"View Trends"}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.Trends.ViewTrends)}
											/>
										</TableRowColumn>,
									]}

								{row.includes("HR_SETTINGS") &&
									[
										<TableRowColumn style={styles.col} key={"pipeline_settings_badge_settings"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsPipelines.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsPipelines.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsPipelines.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsPipelines.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsPipelines.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsPipelines.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsPipelines.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsPipelines.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsBadges.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsBadges.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsBadges.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsBadges.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsBadges.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsBadges.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsBadges.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsBadges.Delete)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key="credential_settings_file_settings">
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsCredentials.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsCredentials.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsCredentials.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsCredentials.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsCredentials.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsCredentials.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsCredentials.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsCredentials.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsFiles.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsFiles.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsFiles.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsFiles.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsFiles.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsFiles.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsFiles.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsFiles.Delete)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key="user_settings_note_checklists_settings">
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsUsers.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_USERS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsUsers.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsUsers.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_USERS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsUsers.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsUsers.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_USERS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsUsers.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsUsers.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_USERS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsUsers.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsChecklistsNotes.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_NOTES_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsChecklistsNotes.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_NOTES_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_NOTES_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_NOTES_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsChecklistsNotes.Delete)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key="hr_jobs_settings_integrations_settings">
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsJobs.View}
												label={checkJobFieldAvailable('singular') ? `View HR ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Settings` : strings.VIEW_ACCOUNT_SETTINGS_HR_JOBS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsJobs.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsJobs.Add}
												label={checkJobFieldAvailable('singular') ? `Add HR ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Settings` : strings.ADD_ACCOUNT_SETTINGS_HR_JOBS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsJobs.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsJobs.Edit}
												label={checkJobFieldAvailable('singular') ? `Edit HR ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Settings` : strings.EDIT_ACCOUNT_SETTINGS_HR_JOBS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsJobs.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsJobs.Delete}
												label={checkJobFieldAvailable('singular') ? `Delete HR ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Settings ` : strings.DELETE_ACCOUNT_SETTINGS_HR_JOBS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsJobs.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsIntegrations.View}
												label={strings.VIEW_ACCOUNT_SETTINGS_INTEGRATIONS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsIntegrations.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsIntegrations.Add}
												label={strings.ADD_ACCOUNT_SETTINGS_INTEGRATIONS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsIntegrations.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsIntegrations.Edit}
												label={strings.EDIT_ACCOUNT_SETTINGS_INTEGRATIONS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsIntegrations.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRSettingsIntegrations.Delete}
												label={strings.DELETE_ACCOUNT_SETTINGS_INTEGRATIONS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRSettingsIntegrations.Delete)}
											/>
										</TableRowColumn>,
									]
								}

								{row.includes("HR_MENU_ACCESS") &&
									[
										<TableRowColumn style={styles.col} key={"pipeline_people"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPipelines.View}
												label={strings.VIEW_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPipelines.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPipelines.Edit}
												label={strings.EDIT_PIPELINES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPipelines.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPeople.View}
												label={strings.VIEW_HR_PEOPLE}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPeople.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPeople.Add}
												label={strings.ADD_HR_PEOPLE}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPeople.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPeople.Edit}
												label={strings.EDIT_HR_PEOPLE}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPeople.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessPeople.Delete}
												label={strings.DELETE_HR_PEOPLE}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessPeople.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCredentials.View}
												label={strings.VIEW_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCredentials.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCredentials.Add}
												label={strings.ADD_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCredentials.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCredentials.Edit}
												label={strings.EDIT_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCredentials.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCredentials.Delete}
												label={strings.DELETE_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCredentials.Delete)}
											/>
										</TableRowColumn>,
										AccountStore.getEnableMessageCenter() &&
										<TableRowColumn style={styles.col} key={"message_center"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessMessageCenter.View}
												label={strings.View_Mobilize}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessMessageCenter.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessMessageCenter.Delete}
												label={strings.Delete_Message}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessMessageCenter.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCampaigns.View}
												label={strings.View_Campaign_Analytics}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCampaigns.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCampaigns.Add}
												label={strings.Create_Campaigns}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCampaigns.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCampaigns.Edit}
												label={strings.Edit_Campaigns}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCampaigns.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessCampaigns.Delete}
												label={strings.Delete_Campaigns}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessCampaigns.Delete)}
											/>
										</TableRowColumn>,
										AccountStore.getEnableATS() &&
										<TableRowColumn style={styles.col} key={"hr_ats"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessATS.View}
												label={strings.View_Job_Postings}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessATS.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessATS.Add}
												label={strings.Add_Job_Postings}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessATS.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessATS.Edit}
												label={strings.Edit_Job_Postings}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessATS.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessATS.Delete}
												label={strings.Delete_Job_Postings}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessATS.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessATS.AllowAccessToAllJobPostings}
												label={strings.Allow_Access_To_All_Job_Postings}
												style={styles.checkBox}
												labelStyle={{ whiteSpace: "initial" }}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessATS.AllowAccessToAllJobPostings)}
											/>
										</TableRowColumn>
									]
								}
								{row.includes("HR_PEOPLE_DETAIL_ACCESS") &&
									[
										<TableRowColumn style={styles.col} key={"status_email_mobile"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.ChangeStatusViaPipeline}
												label={strings.ALLOW_CHANGE_STATUS_VIA_PIPELINE}
												style={styles.checkBox}
												labelStyle={{ whiteSpace: "initial" }}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.ChangeStatusViaPipeline)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.ChangeStatusViaProfilePage}
												label={strings.ALLOW_CHANGE_STATUS_VIA_PROFILE_PAGE}
												style={styles.checkBox}
												labelStyle={{ whiteSpace: "initial" }}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.ChangeStatusViaProfilePage)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.ChangeEmail}
												label={strings.ALLOW_CHANGE_EMAIL}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.ChangeEmail)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.ChangeMobile}
												label={strings.ALLOW_CHANGE_MOBILE}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.ChangeMobile)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.VerifyFilesMissingPrerequisites}
												label={strings.Verify_Files_Missing_Prerequisites}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.VerifyFilesMissingPrerequisites)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"demographics_governmentid_contactinfo_language_ethnicity"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessDemographics.View}
												label={strings.VIEW_DEMOGRAPHICS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessDemographics.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessDemographics.Edit}
												label={strings.EDIT_DEMOGRAPHICS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessDemographics.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessGovernmentId.View}
												label={strings.VIEW_GOVERNMENT_ID}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessGovernmentId.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessGovernmentId.Edit}
												label={strings.EDIT_GOVERNMENT_ID}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessGovernmentId.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessContactInfo.View}
												label={strings.VIEW_CONTACT_INFO}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessContactInfo.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessContactInfo.Edit}
												label={strings.EDIT_CONTACT_INFO}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessContactInfo.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessLanguageEthnicity.View}
												label={strings.VIEW_LANGUAGE_ETHNICITY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessLanguageEthnicity.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessLanguageEthnicity.Edit}
												label={strings.EDIT_LANGUAGE_ETHNICITY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessLanguageEthnicity.Edit)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"bankinfo_paycompesation"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRBankInfo.View}
												label={strings.View_Bank_Info}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRBankInfo.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRBankInfo.Add}
												label={strings.Add_Bank_Info}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRBankInfo.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRBankInfo.Edit}
												label={strings.Edit_Bank_Info}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRBankInfo.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRBankInfo.Delete}
												label={strings.Delete_Bank_Info}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRBankInfo.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.View}
												label={strings.View_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.ViewSalary}
												label={strings.View_Salary_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.ViewSalary)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.ViewHourly}
												label={strings.View_Hourly_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.ViewHourly)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.Add}
												label={strings.Add_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.Edit}
												label={strings.Edit_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRPayCompensation.Delete}
												label={strings.Delete_Pay_Compensation}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRPayCompensation.Delete)}
											/>

										</TableRowColumn>,
										<TableRowColumn style={styles.col}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployee.Rehire}
												label={strings.Allow_Rehire}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployee.Rehire)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRTerminationNotes.Edit}
												label={strings.Edit_Termination_Notes}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRTerminationNotes.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRHireTerminationAudits.Delete}
												label={strings.Delete_Hire_Termination_Audits}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRHireTerminationAudits.Delete)}
											/>
										</TableRowColumn>

									]
								}

								{row.includes("HR_PEOPLE_ACCESS") &&
									[
										<TableRowColumn style={styles.col} key={"speciality_files"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessSpecialties.View}
												label={strings.VIEW_EMPLOYEE_SPECIALTIES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessSpecialties.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessSpecialties.Add}
												label={strings.ADD_EMPLOYEE_SPECIALTIES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessSpecialties.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessSpecialties.Edit}
												label={strings.EDIT_EMPLOYEE_SPECIALTIES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessSpecialties.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessSpecialties.Delete}
												label={strings.DELETE_EMPLOYEE_SPECIALTIES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessSpecialties.Delete)}
											/>

											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeFiles.View}
												label={strings.VIEW_EMPLOYEE_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeFiles.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeFiles.Add}
												label={strings.ADD_EMPLOYEE_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeFiles.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeFiles.Edit}
												label={strings.EDIT_EMPLOYEE_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeFiles.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeFiles.Delete}
												label={strings.DELETE_EMPLOYEE_FILES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeFiles.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeFiles.DeleteVersion}
												label={strings.Allow_for_deletion_of_File_Versions}
												style={styles.checkBox}
												iconStyle={styles.input}
												labelStyle={{ whiteSpace: "initial" }}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeFiles.DeleteVersion)}
											/>
										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"workhistory_education"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessWorkHistory.View}
												label={strings.VIEW_EMPLOYEE_WORK_HISTORY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessWorkHistory.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessWorkHistory.Add}
												label={strings.ADD_EMPLOYEE_WORK_HISTORY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessWorkHistory.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessWorkHistory.Edit}
												label={strings.EDIT_EMPLOYEE_WORK_HISTORY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessWorkHistory.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessWorkHistory.Delete}
												label={strings.DELETE_EMPLOYEE_WORK_HISTORY}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessWorkHistory.Delete)}
											/>

											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEducation.View}
												label={strings.VIEW_EMPLOYEE_EDUCATION}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEducation.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEducation.Add}
												label={strings.ADD_EMPLOYEE_EDUCATION}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEducation.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEducation.Edit}
												label={strings.EDIT_EMPLOYEE_EDUCATION}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEducation.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEducation.Delete}
												label={strings.DELETE_EMPLOYEE_EDUCATION}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEducation.Delete)}
											/>


										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"credentials_checklists"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeCredentials.View}
												label={strings.VIEW_EMPLOYEE_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeCredentials.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Add}
												label={strings.ADD_EMPLOYEE_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Edit}
												label={strings.EDIT_EMPLOYEE_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Delete}
												label={strings.DELETE_EMPLOYEE_CREDENTIALS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeCredentials.Delete)}
											/>

											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeChecklists.View}
												label={strings.VIEW_EMPLOYEE_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeChecklists.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Add}
												label={strings.ADD_EMPLOYEE_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Edit}
												label={strings.EDIT_EMPLOYEE_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Delete}
												label={strings.DELETE_EMPLOYEE_CHECKLISTS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeChecklists.Delete)}
											/>


										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"references_badges"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeReferences.View}
												label={strings.VIEW_EMPLOYEE_REFERENCES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeReferences.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeReferences.Add}
												label={strings.ADD_EMPLOYEE_REFERENCES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeReferences.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeReferences.Edit}
												label={strings.EDIT_EMPLOYEE_REFERENCES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeReferences.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeReferences.Delete}
												label={strings.DELETE_EMPLOYEE_REFERENCES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeReferences.Delete)}
											/>

											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeBadges.View}
												label={strings.VIEW_EMPLOYEE_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeBadges.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeBadges.Add}
												label={strings.ADD_EMPLOYEE_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeBadges.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeBadges.Edit}
												label={strings.EDIT_EMPLOYEE_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeBadges.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeBadges.Delete}
												label={strings.DELETE_EMPLOYEE_BADGES}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeBadges.Delete)}
											/>


										</TableRowColumn>,
										<TableRowColumn style={styles.col} key={"rewards"}>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeRewards.View}
												label={strings.VIEW_EMPLOYEE_REWARDS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeRewards.View)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeRewards.Add}
												label={strings.ADD_EMPLOYEE_REWARDS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeRewards.Add)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeRewards.Edit}
												label={strings.EDIT_EMPLOYEE_REWARDS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeRewards.Edit)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeRewards.Delete}
												label={strings.DELETE_EMPLOYEE_REWARDS}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeRewards.Delete)}
											/>
											<Checkbox
												name={AuthenticationStore.Permissions.HRAccessEmployeeAttributes.View}
												label={strings.View_Employee_Attributes}
												style={styles.checkBox}
												iconStyle={styles.input}
												onCheck={this.handleCheck}
												checked={this.checkForPermissionCheckBox(AuthenticationStore.Permissions.HRAccessEmployeeAttributes.View)}
											/>
										</TableRowColumn>,
									]
								}

								{this.getEmptyColArray(row).map((item, emptyIndex) =>
									<TableRowColumn style={styles.col} key={`emptyCol${emptyIndex}`} />
								)}
							</TableRow>
						</TableBody>
					</Table>
				)}
			</div>
		)
	}
}

const styles = {
	colHeader: { padding: 5, height: 25 },
	col: { paddingLeft: 5, paddingRight: 5, verticalAlign: "initial" },
	checkBox: { marginTop: 5, marginBottom: 5 },
	input: { marginRight: 5 }
}